import React from 'react'

export default function NewActionButton({ classNames = "btn-outline-success", text = "", disabled = false, isButton = false, ...props }) {
    const currentLanguage = localStorage.getItem('eahsLang');
    function hasNumber(str) {
        return /\d/.test(str);
    }
    if (isButton) {
        return (
            <button className={`btn ${classNames}   rounded w-100 ${disabled ? 'disabled' : ''}`} {...props} style={currentLanguage == 'en' ? { fontSize: hasNumber(text) ? '0.8rem' : '1rem' } : { height: 38, lineHeight: '30px',fontSize: hasNumber(text) ? '0.8rem' : '1rem' }}>
                {currentLanguage == 'en' ? <>
                    {text}
                </>
                    :
                    <div style={{ marginTop: -4 }}>
                        {text}
                    </div>
                }
            </button>
        )
    } else {
        return (
            <div className={`btn ${classNames}  rounded w-100 ${disabled ? 'disabled' : ''}`} {...props} style={currentLanguage == 'en' ? {fontSize: hasNumber(text) ? '0.8rem' : '1rem'} : { height: 38, lineHeight: '30px',fontSize: hasNumber(text) ? '0.8rem' : '1rem' }}>
                {currentLanguage == 'en' ? <>
                    {text}
                </>
                    :
                    <div style={{ marginTop: -4 }}>
                        {text}
                    </div>
                }
            </div>
        )
    }
}
